// src/pages/Shipping.js
import React, { useState, useEffect } from "react";
import axios from "../api/axios"; // Ajusta la ruta si tu archivo axios está en otro lado


const Shipping = () => {
  const [file, setFile] = useState(null);
  const [message, setMessage] = useState("");
  const [datesStats, setDatesStats] = useState([]);

  // Al montar el componente, cargamos las estadísticas de fechas
  useEffect(() => {
    const fetchDatesStats = async () => {
      try {
        const { data } = await axios.get("/shipping/dates-stats");
        setDatesStats(data); // data es un array de objetos { date, count }
      } catch (error) {
        console.error("Error al obtener estadísticas de fechas:", error);
        setMessage("Error al obtener estadísticas de fechas.");
      }
    };
    fetchDatesStats();
  }, []);

  // Manejar la subida del Excel
  const handleUpload = async () => {
    if (!file) {
      setMessage("Selecciona un archivo Excel primero.");
      return;
    }
    try {
      const formData = new FormData();
      formData.append("file", file);
      // POST /api/shipping/upload
      const { data } = await axios.post("/shipping/upload", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      setMessage(data.message || "Fechas actualizadas correctamente.");

      // Tras actualizar, volvemos a cargar las estadísticas
      const statsRes = await axios.get("/shipping/dates-stats");
      setDatesStats(statsRes.data);
    } catch (error) {
      console.error("Error al subir el archivo de fechas:", error);
      setMessage("Error al subir el archivo de fechas.");
    }
  };

  return (
    <div className="flex">
      <div className="flex-1 p-6 ml-64 bg-gray-100 min-h-screen">
        <h1 className="text-3xl font-bold mb-6">Administrar Fechas de Envío</h1>

        {/* Mensaje de estado */}
        {message && (
          <div className="mb-4 p-3 bg-blue-100 border-l-4 border-blue-500 text-blue-700">
            {message}
          </div>
        )}

        {/* Sección para subir Excel */}
        <div className="bg-white p-6 rounded shadow-md mb-6 max-w-md">
          <h2 className="text-xl font-bold mb-4">Subir Archivo de Fechas</h2>
          <input
            type="file"
            accept=".xlsx,.xls,.csv"
            onChange={(e) => setFile(e.target.files[0])}
            className="mb-4"
          />
          <button
            onClick={handleUpload}
            className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
          >
            Subir
          </button>
        </div>

        {/* Sección para mostrar estadísticas de fechas */}
        <div className="bg-white p-6 rounded shadow-md">
          <h2 className="text-xl font-bold mb-4">Fechas Disponibles y Cantidad de Pedidos</h2>
          {datesStats.length === 0 ? (
            <p>No hay fechas disponibles o no se han realizado pedidos.</p>
          ) : (
            <table className="min-w-full bg-white">
              <thead>
                <tr>
                  <th className="py-2 px-4 border-b">Fecha</th>
                  <th className="py-2 px-4 border-b">Pedidos</th>
                </tr>
              </thead>
              <tbody>
                {datesStats.map(({ date, count }) => (
                  <tr key={date}>
                    <td className="py-2 px-4 border-b">{date}</td>
                    <td className="py-2 px-4 border-b">{count}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </div>
  );
};

export default Shipping;
